var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDevelopment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 83,
  height: 83,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M67.555 17.28 43.246 41.589l-4.1-4.1 24.309-24.31z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "m72.534 15.816-4.979 1.464-4.1-4.1 1.464-4.98z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "m72.534 15.816 4.393-7.908-4.1-4.1L64.919 8.2z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB3737",
  d: "M47.054 45.397 19.23 73.22A8.284 8.284 0 1 1 7.515 61.505l27.823-27.824z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#656565",
  d: "M62.936 53.114a2.87 2.87 0 0 1-2.433-.819L30.19 21.983a2.89 2.89 0 0 1-.782-2.645c.87-4.171-.296-8.69-3.524-11.918a12.96 12.96 0 0 0-10.676-3.722c-1.204.136-1.689 1.614-.832 2.47l6.07 6.07-1.727 6.469-6.468 1.726-6.07-6.07c-.857-.856-2.347-.36-2.483.845a12.96 12.96 0 0 0 3.685 10.64c3.178 3.202 7.734 4.38 11.93 3.51a2.9 2.9 0 0 1 2.62.782l30.362 30.363c.646.645.944 1.54.82 2.433-.572 4.048.967 8.343 4.678 11.061 4.146 3.029 9.994 2.867 14.005-.325 5.5-4.408 5.824-12.453.995-17.281a11.54 11.54 0 0 0-9.857-3.277m7.299 9.956-1.516 5.662-5.661 1.515-4.146-4.146 1.515-5.661 5.662-1.516z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#B9B9B9",
  d: "M57.399 57.41a2.177 2.177 0 0 1-3.08.001L24.604 27.694a2.177 2.177 0 1 1 3.08-3.079l29.729 29.73c.844.843.843 2.21-.013 3.066"
})));
export default SvgDevelopment;